import { ShiftsLeaveFragment } from 'generated/resources/graphql'
import { groupBy, uniq } from 'lodash'
import { computed, makeObservable } from 'mobx'
import type moment from 'moment'

import Leave from 'modules/shift_management/store/internal/models/Leave'

class Leaves {
  leaves: Leave[]

  constructor(leaves: Leave[]) {
    this.leaves = leaves

    makeObservable(this, {
      leavesLength: computed,
      leaveTypes: computed,
      _groupByType: computed,
    })
  }

  static buildFromGraphQL(
    leaves: ShiftsLeaveFragment[],
    employeeAvatar: string,
    employeeFullName: string
  ): Leaves {
    const leaveObjects = leaves.map((leave) =>
      Leave.buildFromGraphQL(leave, employeeAvatar, employeeFullName)
    )

    return new Leaves(leaveObjects)
  }

  get leavesLength(): number {
    return this.leaves.length
  }

  get leaveTypes(): string[] {
    return uniq(this.leaves.map((leave) => leave.typeName))
  }

  get _groupByType(): Record<string, Leave[]> {
    return groupBy(this.leaves, 'typeName')
  }

  filterByDate(date: moment.Moment): Leave[] {
    return this.leaves.filter((leave) => leave.isDuring(date))
  }

  filterByDateApproved(date: moment.Moment): Leave[] {
    return this.leaves.filter((leave) => leave.isDuring(date) && leave.approved)
  }

  filterByType(type: string): Leave[] {
    return this._groupByType[type] || []
  }
  filterByNonEmployeeIds(employeeIds: number[]): Leave[] {
    return this.leaves.filter((leave) => !employeeIds.includes(leave.employeeId))
  }
}

export default Leaves
